import * as React from "react";
const SvgIconCheckboxOff = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 11, height: 11, rx: 1.5, stroke: "#C3E7E2" }));
export default SvgIconCheckboxOff;
